import React from "react";
import styled from "styled-components";
import Wrapper from "../atoms/Wrapper";
import AdSense from "react-adsense";

const OuterWrapper = styled(Wrapper)`
  width: 100%;
  height: fit-content;
`;

const VideoStreamItemAd = props => {
  if (props.type === "new") {
    return (
      <OuterWrapper>
        <AdSense.Google
          format="fluid"
          client="ca-pub-6203998847017583"
          slot="8998371472"
          layoutKey="-fu+52+56-cp+49"
          style={{ width: "100%", display: "block" }}
        />
      </OuterWrapper>
    );
  }

  if (props.type === "clip") {
    return (
      <OuterWrapper>
        <AdSense.Google
          format="fluid"
          client="ca-pub-6203998847017583"
          slot="8998371472"
          layoutKey="-fu+52+56-cp+49"
          style={{ width: "100%", display: "block" }}
        />
      </OuterWrapper>
    );
  }

  if (props.type === "vtuber") {
    return (
      <OuterWrapper>
        <AdSense.Google
          format="fluid"
          client="ca-pub-6203998847017583"
          slot="4742080620"
          layoutKey="-fb+5w+4e-db+86"
          style={{ width: "100%", display: "block" }}
        />
      </OuterWrapper>
    );
  }

  return (
    <OuterWrapper>
      <AdSense.Google
        format="fluid"
        client="ca-pub-6203998847017583"
        slot="2419401123"
        layoutKey="-h7-k+2a-7b+b9"
        style={{ width: "100%", display: "block" }}
      />
    </OuterWrapper>
  );
};

export default VideoStreamItemAd;
